<template>
  <div>
    <v-row justify="center" class="pa-0 ma-0" v-scroll="onScroll">
      <!-- Event image -->
      <v-col v-if="!hasProductList" class="pa-0" cols="12">
        <template v-if="eventDetailsLoaded">
          <v-img
            v-if="showImage"
            width="100vw"
            :position="imgPosition"
            :aspect-ratio="1.618 / 1"
            :style="videoMaxHeight"
            :src="$store.getters.getCurrentDetailsForEventPage.Picture"
          >
            <!-- Favorite Icon -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  outlined
                  absolute
                  color="red accent-3"
                  class="favourite-icon"
                  style="background-color: white"
                  v-bind="attrs"
                  v-on="on"
                  @click="toggleFavourite()"
                >
                  <v-icon color="red accent-3">
                    {{ isEventAFavourite() }}
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $translate('ADD_FAVORITE') }}</span>
            </v-tooltip>

            <!-- Video button -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="showInfoUrl"
                  v-bind="attrs"
                  v-on="on"
                  large
                  fab
                  color="primary"
                  class="video-btn"
                  @click="openYoutube(componentEventDetails.InfoUrl)"
                >
                  <v-icon large>mdi-web</v-icon>
                </v-btn>
              </template>
              <span>{{ $translate('SHOW_URL') }}</span>
            </v-tooltip>
          </v-img>
        </template>
        <v-skeleton-loader
          v-else
          type="image"
          width="100vw"
          :height="bannerHeight"
          tile
        />
      </v-col>

      <v-col cols="12">
        <v-row justify="center">
          <!-- Left sidebar: breakpoints mdAndUp -->
          <v-col v-if="isPromotionDetails && mdAndUp" cols="2" class="mt-7">
            <HomepageContainer :structure="homepageStructure.leftSide" />
          </v-col>

          <v-col class="px-md-10" cols="12" md="8">
            <!-- Event name, description, subscription button -->
            <section v-if="!hasProductList" class="mb-8">
              <!-- Event Name -->
              <div class="text-break mx-auto">
                <h1 class="primary--text homepageTitle py-2 mb-2 text-center">
                  {{ $store.getters.getCurrentDetailsForEventPage.Name }}
                </h1>

                <!-- Event Description -->
                <div
                  class="pa-0 descriptionFontSize"
                  v-html="
                    $store.getters.getCurrentDetailsForEventPage.Description
                  "
                />

                <!-- embedded video -->
                <v-card
                  class="pa-1"
                  :class="mdAndUp ? 'embeddedVideo' : ''"
                  v-if="showVideo"
                >
                  <video
                    class="mb-4"
                    :width="mdAndUp ? '250px' : '100%'"
                    :height="mdAndUp ? '' : '300px'"
                    :src="componentEventDetails.VideoUrl"
                    controls
                    :style="videoMaxHeight"
                  ></video>
                </v-card>
              </div>

              <!-- Button to create subscription -->
              <v-row justify="center" class="ma-0 mt-2">
                <v-btn
                  v-if="showSubscriptionBtn"
                  color="primary"
                  class="text-capitalize mb-2 primary-font-color"
                  min-width="40%"
                  @click="onCreateSubscription"
                >
                  {{ $translate('CREATE_SUBSCRIPTION') }}
                </v-btn>
              </v-row>
            </section>

            <!-- Stay informed block for promotions -->
            <v-col
              v-if="
                isPromotion &&
                componentEventDetails.CohortIdsForSubscription.length !== 0 &&
                $store.getters['auth/userName'] !== '' &&
                !hidePromotionBox
              "
              cols="12"
              class="pa-0"
            >
              <!-- information about subscription for promotion -->
              <v-row class="justify-start mx-4 mt-2">
                <h3 class="mb-0 align-self-center mr-1">
                  {{ $translate('PROMOTIONS_INFORMATION') }}
                </h3>
                <v-text-field
                  v-if="$store.getters['auth/userName'] === ''"
                  solo
                  class="font-weight-bold ml-4 test"
                  :label="$translate('email')"
                ></v-text-field>
                <v-btn
                  depressed
                  @click.stop="checkUserSubscriptions(componentEventDetails)"
                >
                  <v-icon large color="red">favorite_border</v-icon>
                  <h3 class="mb-0 ml-0 ml-sm-4">
                    {{ $translate('PROMOTIONS_STAY_INFORMED') }}
                  </h3>
                </v-btn>
              </v-row>
            </v-col>

            <!-- Previous and Next promotion buttons -->
            <EventPreviousNextPromotion :eventDetails="componentEventDetails" />

            <EventInstantProductDetails
              id="instantProductDetails"
              v-if="hasProductList"
              :btnSize="btnSize"
              :eventDetails="componentEventDetails"
              :scrollToSection="true"
              @bookButtonPressed="bookProducts"
              @bookRentalButtonPressed="rentalFlowReserve"
              ref="instantProductDetails"
            />

            <!-- Auction Event main -->
            <EventDetails_Auction
              v-if="isAuction"
              if="eventDetailsAuction"
              :eventDetails="componentEventDetails"
            />

            <EventDetailsProducts
              id="eventDetailsProducts"
              v-if="hasProducts"
              :btnSize="btnSize"
              :eventDetails="componentEventDetails"
              @bookButtonPressed="bookProducts"
            />

            <!-- Template items -->
            <div
              v-if="
                componentEventDetails.TemplateItems != null &&
                componentEventDetails.TemplateItems.length > 0 &&
                componentEventDetails.TemplateType > 0
              "
              class="px-3 px-sm-0"
            >
              <EventTemplateOne
                v-if="componentEventDetails.TemplateType === 1"
                :eventDetails="componentEventDetails"
              ></EventTemplateOne>

              <EventTemplateTwo
                v-if="componentEventDetails.TemplateType === 2"
                :eventDetails="componentEventDetails"
              ></EventTemplateTwo>

              <EventTemplateThree
                v-if="componentEventDetails.TemplateType === 3"
                :eventDetails="componentEventDetails"
              ></EventTemplateThree>
            </div>

            <!-- Button to join the quiz -->
            <v-row v-if="isQuizEvent && showJoinButton" align="center" justify="center" class="ma-0">
              <v-col cols="12" md="8" lg="6">
                <v-btn
                  v-if="Object.keys(promotions).length > 0 && promotions.Translations[languageId] && promotions.Translations[languageId].JoinText"
                  :disabled="false"
                  block
                  depressed
                  @click="joinQuiz"
                  color="primary"
                >
                  {{ this.promotions.Translations[this.languageId].JoinText }}
                </v-btn>
                <v-btn
                  v-else
                  :disabled="false"
                  block
                  depressed
                  @click="joinQuiz"
                  color="primary"
                >
                  {{ componentEventDetails.JoinText ?  componentEventDetails.JoinText : $translate('JOIN_QUIZ') }}
<!--                  {{ $translate('JOIN_QUIZ') }}-->
                </v-btn>
              </v-col>
            </v-row>

            <!-- Col for suggestions -->
            <EventSuggestions
              v-if="hasSuggetions"
              class="mt-4"
              :eventDetails="componentEventDetails"
              :suggestions="suggestions"
              id="eventDetailsSuggestions"
            />

            <Booking_Details_Events
              v-if="currentComponent === 'Booking_Details_Events'"
              :eventDetails="componentEventDetails"
              :rentalData="rentalData"
            />

            <!-- Event Info -->
            <EventDetailsTickets
              v-if="isBookableEvent"
              id="eventDetailsTickets"
              :btnSize="btnSize"
              :eventDetails="componentEventDetails"
              @bookButtonPressed="getCurrentComponent('Booking_Details_Events')"
            />

            <Booking
              v-if="currentComponent === 'BookingDetailsProducts'"
              :eventDetails="{}"
              goToComponent="Order"
              @eventDetailBack="$router.go(-1)"
              @bookButtonPressed="getCurrentComponent('Booking')"
            />

            <!-- Row for Event Reviews -->
            <v-row class="mt-8" v-if="reviewAllowed && mdAndUp">
              <v-col
                cols="12"
                id="reviewSection"
                v-if="Object.keys(componentEventDetails).length"
              >
                <EventDetailsInfoReviews
                  :eventDetails="componentEventDetails"
                />
              </v-col>
            </v-row>
          </v-col>

          <!-- Right sidebar: breakpoints mdAndUp -->
          <v-col v-if="isPromotionDetails && mdAndUp" cols="2" class="mt-7">
            <HomepageContainer :structure="homepageStructure.rightSide" />
          </v-col>
        </v-row>
      </v-col>

      <!-- Side bars: breakpoints smAndDown -->
      <v-col v-if="!mdAndUp" cols="12">
        <v-col v-if="isPromotionDetails" cols="12" order="2" class="pa-0 mt-6">
          <TrendingProducts v-if="productFocused" />
          <TrendingEvents v-else />
        </v-col>

        <ActivityCalendar v-if="isPromotionDetails" class="mt-6" />

        <!-- Row for Event Reviews -->
        <v-row v-if="reviewAllowed">
          <v-col
            cols="12"
            id="reviewSection"
            v-if="Object.keys(componentEventDetails).length"
          >
            <EventDetailsInfoReviews :eventDetails="componentEventDetails" />
          </v-col>
        </v-row>

        <AppDownloadButtons v-if="isPromotionDetails" class="mt-6" />
      </v-col>

      <!-- Success dialog -->
      <SuccessDialog
        :dialog="successDialog"
        :successText="paymentMsg"
        @continue="goToMyActivities()"
        @back="goHome()"
      />
      <!-- Subscription dialog -->
      <v-dialog
        max-width="480"
        v-model="addUserToSubscriptionsDialog"
        persistent
      >
        <v-card>
          <h3 class="pa-5">
            {{ getSubscriptionText() }}
          </h3>
          <v-card
            class="ma-2"
            elevation="1"
            v-for="(subs, index) in possibleSubscriptions"
            :key="index"
          >
            <v-card-text>
              <b>{{ subs.Name }}</b>
              <v-switch
                class="px-5"
                v-model="subs.MailSwitch"
                :label="$translate('SUBSCRIPTION_EMAILS')"
              />
              <v-switch
                class="px-5"
                v-model="subs.PushSwitch"
                :label="$translate('SUBSCRIPTION_PUSH')"
              />
            </v-card-text>
          </v-card>
          <v-card-actions>
            <v-btn
              color="secondary"
              @click="addUserToSubscriptionsDialog = false"
            >
              {{ $translate('CANCEL') }}
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              class="primary-font-color"
              @click="changeSubscriptions"
            >
              {{ $translate('OK') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- chat button -->
    <v-tooltip v-if="!hasProductList" top>
      <template v-slot:activator="{ on, attrs }">
        <v-fab-transition>
          <v-btn
            :disabled="!Object.keys(mainPartner).length"
            color="secondary"
            fab
            fixed
            large
            dark
            @click="getDefaultChatMessagesAndCategories(mainPartner)"
            v-bind="attrs"
            v-on="on"
            bottom
            right
            class="specialRequestButton"
          >
            <v-badge
              v-if="selectedChat.UnreadMessages > 0"
              color="red"
              :content="selectedChat.UnreadMessages"
            >
              <v-icon class="secondary-font-color">chat</v-icon>
            </v-badge>
            <v-icon v-else class="secondary-font-color"> chat</v-icon>
          </v-btn>
        </v-fab-transition>
      </template>
      <span>Open chats</span>
    </v-tooltip>
    <!-- end of chat button -->

    <v-dialog
      transition="dialog-bottom-transition"
      fullscreen
      hide-overlay
      v-model="chatDialogOpen"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn class="mr-4" icon dark @click="chatDialogOpen = false">
            <v-icon>remove</v-icon>
          </v-btn>
          {{ $translate('YOUR_CHAT_WITH') }} {{ mainPartner.Name }}
        </v-toolbar>
        <chat-bubble
          v-if="chatDialogOpen"
          :selectedPartner="mainPartner"
          :currentChat="selectedChat"
          :categories="defaultCategories"
          @getMessagesForUser="getMessagesForUser"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import eventDetailsPageMixin from '@/mixins/eventDetails';
import ActivityCalendar from '@/components/homepage/ActivityCalendar.vue';
import AppDownloadButtons from '@/components/homepage/appDownload/AppDownloadButtons.vue';
import UserJS from '@/objects/UserObject';
import { addLog } from '@/api/dssRequest';

export default {
  name: 'EventDetailsClassicView',
  mixins: [eventDetailsPageMixin],
  components: {
    ActivityCalendar,
    AppDownloadButtons,
    TrendingProducts: () =>
      import('@/components/homepage/trendingProducts/TrendingProducts.vue'),
    TrendingEvents: () =>
      import('@/components/homepage/trendingEvents/TrendingEvents.vue'),
  },
  props: {
    eventDetails: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      languageId: this.$store.getters['auth/userLanguage'].LanguageId,
      promotions: {},
      showJoinButton: true,
    };
  },
  mounted() {
    this.fetchPromotions();
    const url_string = window.location.href;
    const url = new URL(url_string);
    if(url.searchParams.get('SourceKey')){
      addLog(
        this.$store.getters['auth/userObjectId'],
        this.currentEventDetails.Id,
        'Event',
        'Email',
        -1
      );
    }
  },
  methods: {
    async fetchPromotions() {
      try {
        const getPromotionsData = await UserJS.getPromotions();
        const promotionsData = getPromotionsData.data.Promotions;

        if (promotionsData) {
          const matchingPromotion = promotionsData.find(
            (promotion) => promotion.Name === this.$store.getters.getCurrentDetailsForEventPage.Name
          );

          if (matchingPromotion) {
            console.log(
              "Gevonden overeenkomende promotie:",
              matchingPromotion
            );
            this.promotions = matchingPromotion;
            this.calculateShowJoinButton();
          } else {
            console.warn(
              "Geen overeenkomende promotie gevonden voor de naam:",
              eventName
            );
          }
        }
      } catch (error) {
        console.error("Fout bij het ophalen van promoties:", error);
      }
    },
    calculateShowJoinButton() {
      const currentDateTime = new Date();
      const [dateString, timeString] = this.promotions.DeadlineDate.split(' ');
      const [day, month, year] = dateString.split('-');
      const [hours, minutes] = timeString.split(':');
      const deadlineDateTime = new Date(year, month - 1, day, hours, minutes);
      console.log(this.promotions.DeadlineDate)
      if (this.promotions.DeadlineDate === '01-01-1970 00:00') {
        this.showJoinButton = true;
      } else if (currentDateTime > deadlineDateTime) {
        this.showJoinButton = false;
      } else {
        this.showJoinButton = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.specialRequestButton {
  margin: 0 0 16px 16px;
  z-index: 90;
}

.embeddedVideo {
  z-index: 90;
  left: 16px;
  bottom: 16px;
  position: fixed;
}

.video-btn {
  position: absolute;
  bottom: 13px;
  right: 13px;
}

.favourite-icon {
  top: 13px;
  left: 13px;
}

.favourite-icon-on-video {
  top: 10px;
  left: 10px;

  @media screen and (min-width: 961px) {
    top: 20px;
    left: 13px;
  }

  @media screen and (min-width: 1265px) {
    top: 28px;
    left: 13px;
  }
}

::v-deep .v-skeleton-loader.v-skeleton-loader--is-loading {
  .v-skeleton-loader__image {
    height: 100%;
  }
}
.descriptionFontSize {
  @media only screen and (min-width: 960px) {
    font-size: 20px;
  }
}
::v-deep .ql-size-small{
    font-size: small;
  }
  ::v-deep .ql-size-large{
    font-size: 28px;
  }
  ::v-deep .ql-size-huge{
    font-size: 35px;
  }
</style>
